import packageJson from '../../package.json';

/** npm package name (alea-tui-app). */
export const APP_PACKAGE_NAME = packageJson.name;

/** Semantic version from package.json. */
export const APP_VERSION = packageJson.version;

/** Human-readable product name shown in UI, PWA, and native shells. */
export const APP_DISPLAY_NAME = 'Alea TUI';

export const APP_SHORT_NAME = 'Alea';

export const APP_DESCRIPTION = 'Alea TUI operations console';

/** Capacitor / native bundle identifier (unchanged until store migration). */
export const APP_ID = 'com.labolita.app';

/** Supported UI themes. */
export const THEMES = ['system', 'light', 'dark'];

export const DEFAULT_THEME = 'system';

/** Supported UI languages. */
export const LANGUAGES = ['es', 'en'];

export const DEFAULT_LANGUAGE = 'es';
